import React from 'react';
import { Footer, Header } from '../../../components';
import { Col, Img, MainContainer, Row } from 'ui/layout';
import styled from 'styled-components';
import ill2 from 'assets/partners/ill2.png';
import { BREAKPOINTS, COLORS } from '../../../utils';
import PDF1 from '../obshtie-usloviya-arendy-tehniki-s-ekipazhem-redakciya-1-ot-15-10-2024-0.pdf';
import PDF2 from '../obshtie-usloviya-okazaniya-avtotransportnyh-uslug-redakciya-1-ot-15-10-2024-0.pdf';
import PDF3 from '../obshtie-usloviya-arendy-avtomobilnogo-transporta-s-ekipazhem-redakciya-1-ot-15-10-2024-0.pdf';
import PDF4 from '../obshtie-usloviya-okazaniya-uslug-specialnoj-tehnikoj-redakciya-1-ot-15-10-2024-0.pdf';
import PDF11 from '../obshtie-usloviya-arendy-tehniki-s-ekipazhem-redakciya-1-ot-15-10-2024-2.pdf';
import PDF21 from '../obshtie-usloviya-okazaniya-avtotransportnyh-uslug-redakciya-1-ot-15-10-2024-2.pdf';
import PDF31 from '../obshtie-usloviya-arendy-avtomobilnogo-transporta-s-ekipazhem-redakciya-1-ot-15-10-2024-2.pdf';
import PDF41 from '../obshtie-usloviya-okazaniya-uslug-specialnoj-tehnikoj-redakciya-1-ot-15-10-2024-2.pdf';
import PDF13 from '../obshtie-usloviya-arendy-tehniki-s-ekipazhem-redakciya-1-ot-15-10-2024-3.pdf';
import PDF23 from '../obshtie-usloviya-okazaniya-avtotransportnyh-uslug-redakciya-1-ot-15-10-2024-3.pdf';
import PDF33 from '../obshtie-usloviya-arendy-avtomobilnogo-transporta-s-ekipazhem-redakciya-1-ot-15-10-2024-3.pdf';
import PDF43 from '../obshtie-usloviya-okazaniya-uslug-specialnoj-tehnikoj-redakciya-1-ot-15-10-2024-3.pdf';
import { ButtonBack } from '../../../ui/components';

export const PartnersArchivePage = () => {
  return (
    <div>
      <Header active={'partners'} />

      <Wrapper>
        <MainContainer>
          <Row alignItems={'flex-start'}>
            <TextCol width={'35%'} xlWidth={'42%'} lgWidth={'100%'}>
              <ButtonBack title={'Назад'} link={'/partners'}/>
              <H1>
                Архив
              </H1>
              <Row marginTop={20} direction='column' gap>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF3}
                >
                  1.ОБЩИЕ УСЛОВИЯ аренды автомобильного транспорта с экипажем
                  (редакция №1 от 15.10.2024)
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF1}
                >
                  2.ОБЩИЕ УСЛОВИЯ аренды техники с экипажем (редакция №1 от
                  15.10.2024){' '}
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF2}
                >
                  3.ОБЩИЕ УСЛОВИЯ оказания автотранспортных услуг (редакция №1
                  от 15.10.2024){' '}
                </DownloadLink>

                <DownloadLink
                  href={PDF4}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  4.ОБЩИЕ УСЛОВИЯ оказания услуг специальной техникой (редакция
                  №1 от 15.10.2024){' '}
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF31}
                >
                  5.ОБЩИЕ УСЛОВИЯ аренды автомобильного транспорта с экипажем
                  (редакция №2 от 01.04.2025){' '}
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF11}
                >
                  6.ОБЩИЕ УСЛОВИЯ аренды техники с экипажем (редакция №2 от 01.04.2025){' '}
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF41}
                >
                  7.ОБЩИЕ УСЛОВИЯ оказания услуг специальной техникой (редакция №2 от 01.04.2025){' '}
                </DownloadLink>

                <DownloadLink
                  href={PDF21}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  8.ОБЩИЕ УСЛОВИЯ оказания автотранспортных услуг (редакция №2 от 01.04.2025){' '}
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF33}
                >
                  9.ОБЩИЕ УСЛОВИЯ аренды автомобильного транспорта с экипажем (редакция №3 от 01.01.2026)
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF13}
                >
                  10.ОБЩИЕ УСЛОВИЯ аренды техники с экипажем (редакция №3 от 01.01.2026)
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF43}
                >
                  11.ОБЩИЕ УСЛОВИЯ оказания услуг специальной техникой (редакция №3 от 01.01.2026)
                </DownloadLink>

                <DownloadLink
                  href={PDF23}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  12.ОБЩИЕ УСЛОВИЯ оказания автотранспортных услуг (редакция №3 от 01.01.2026)
                </DownloadLink>
              </Row>
              <FeedbackContainer>
                Обратная связь:{' '}
                <PostLink href='mailto:info@allgk.ru'>info@allgk.ru</PostLink>
              </FeedbackContainer>
            </TextCol>
            <Col width={'65%'} xlWidth={'58%'} lgHidden paddingLeft={3}>
              <Ill2 src={ill2} alt={''} />
            </Col>
          </Row>
        </MainContainer>

        <Ill2Tablet src={ill2} alt={''} />
      </Wrapper>

      <Footer />
    </div>
  );
};

const Wrapper = styled.div`
  position: relative;
  padding-top: 137px;
  padding-bottom: 138px;

  @media (max-width: ${BREAKPOINTS.lg}px) {
    padding-top: 132px;
    padding-bottom: 0;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    padding-top: 55px;
    padding-bottom: 27px;
  }

  :before {
    content: '';
    position: absolute;
    left: -76px;
    top: 0;
    height: 89px;
    width: 100px;
    background: #0c67b1;
    transform: skew(-30deg);
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    :before {
      height: 26px;
      left: -90px;
      top: 32px;
    }
  }
`;
const H1 = styled.h1`
  font-weight: 600;
  font-size: 48px;
  line-height: 58px;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    font-size: 38px;
    line-height: 46px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    font-size: 25px;
    line-height: 30px;
  }
`;

const TextCol = styled(Col)`
  @media (max-width: ${BREAKPOINTS.smd}px) {
    padding-left: 21px;
  }
`;
const FeedbackContainer = styled.div`
  margin-top: 53px;
  min-height: 53px;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    margin-top: 19px;
    max-width: 289px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    max-width: 205px;
    margin-top: 24px;
  }
`;
const PostLink = styled.a`
  text-decoration: none;
  font-weight: 600;
  color: ${COLORS.primary1};
  :hover {
    opacity: 0.6;
  }
`;
const Ill2 = styled(Img)`
  width: 100%;
  height: 525px;
  object-fit: cover;
`;
const Ill2Tablet = styled(Img)`
  display: none;
  width: 100%;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    display: block;
    margin-top: 136px;
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    margin-top: 26px;
  }
`;

const DownloadLink = styled.a`
  margin-bottom: 12px;
  text-decoration: none;
  font-weight: 600;
  color: ${COLORS.primary1};
  cursor: pointer;
  :hover {
    opacity: 0.6;
  }
`;